export default __webpack_public_path__ + "static/media/WildLandsOfZelata.5d0629b0.jpg";